import { InjectionToken } from '@angular/core';
import { TComponentController } from '../models/scan-component-controller.model';

export const ScanComponentControllerToken = new InjectionToken<TComponentController[]>(
  'Abstract scan component controller'
);
